export default "__VITE_ASSET__7ed5bc02__"